import { render, staticRenderFns } from "./Pixel.vue?vue&type=template&id=7b81cc5c&scoped=true&"
import script from "./Pixel.vue?vue&type=script&lang=js&"
export * from "./Pixel.vue?vue&type=script&lang=js&"
import style0 from "./Pixel.vue?vue&type=style&index=0&id=7b81cc5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b81cc5c",
  null
  
)

export default component.exports